//noScroll
class SnsNavi {
  constructor(el,opt){
    this.el = el;
    this.event();
  }
  event(){
    $(window).on("scroll", function() {
      let scrollPosition = $(this).height() + $(this).scrollTop();
      let dispHeight = $(".js-footer").offset().top;

      if(scrollPosition > dispHeight + 300){
        $(".l-header__sns").fadeOut(300);
      } else {
        $(".l-header__sns").fadeIn(300);
      }
    });
  }
}
 